<template>
  <div>
    <div class="background-div" :style="{ backgroundImage: 'url(' + imageUrl + ')' }">


      <div style="position: absolute;margin-top: 10px;margin-left: 5%;color: #41778c;z-index: 99999;">

        <el-dropdown :hide-on-click="false">
          <span class="el-dropdown-link setting-button" >
            设置
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item>
              <el-dropdown @command="handleCommand" :hide-on-click="false">
                <span class="el-dropdown-link" style="color: #41778c;font-size: 1.3vw">
                  切换背景
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="nbk1">背景1</el-dropdown-item>
                  <el-dropdown-item command="nbk2">背景2</el-dropdown-item>
                  <el-dropdown-item command="nbk3">背景3</el-dropdown-item>
                  <el-dropdown-item command="nbk4">背景4</el-dropdown-item>
                  <el-dropdown-item command="nbk5">背景5</el-dropdown-item>
                  <el-dropdown-item command="nbk6">背景6</el-dropdown-item>
                  <el-dropdown-item command="nbk7">背景7</el-dropdown-item>
                  <el-dropdown-item command="nbk8">背景8</el-dropdown-item>
                  <el-dropdown-item command="nbk9">背景9</el-dropdown-item>
                  <el-dropdown-item command="nbk10">背景10</el-dropdown-item>
                  <el-dropdown-item command="nbk11">背景11</el-dropdown-item>
                  <el-dropdown-item command="js">7中教室</el-dropdown-item>

                </el-dropdown-menu>
              </el-dropdown>

            </el-dropdown-item>
            <!-- <el-dropdown-item>
                      <el-dropdown @command="handleCommandModel" :hide-on-click="false" >
              <span class="el-dropdown-link" style="color: #41778c;font-size: 1.3vw">
                  切换模型
              </span>
              <el-dropdown-menu slot="dropdown" >
                    <el-dropdown-item command="70001">女生</el-dropdown-item>
                    <el-dropdown-item command="70002">男生</el-dropdown-item>
              </el-dropdown-menu>
          </el-dropdown>
                    </el-dropdown-item>
   -->
          </el-dropdown-menu>
        </el-dropdown>



      </div>

      <div class="content" style="display: flex;width: 100%;height: 100%;">
        <div class="canvas-show">
          <canvas id="unity-canvas" style="width: 100%; height: 100%;"></canvas>
        </div>
        <div class="gitContainer" v-if="showGif">
          <img src="../assets/img/1.gif" alt="GIF" style="vertical-align: middle;"> <span
            style="font-size:1.2rem ;vertical-align: middle;">{{ remainingTime }}秒</span>
          <div style="font-size:1.2rem ;">我正在听您说话...</div>
          <button class="custom-gif-button" @click="dealIatStop">说完了</button>
        </div>
        <div class="show-window">


          <div class="show-content" ref="scrollContainer" v-show="chatHistory && chatHistory.length > 0">


            <div v-for="(record, index) in chatHistory" :key="index">
              <div v-if="record.reqContent"
                style="display: flex;justify-content: flex-end;margin-top: 20px;width: 100%;">
                <div class="reqContent">
                  {{ record.reqContent }}
                </div>
                <div>
                  <img src="../assets/img/qt.png"  class="qt"  />
                </div>
              </div>



              <div v-if="record.resContent"
                style="display: flex;justify-content: flex-start;align-self: self-start;margin-top: 20px">
                <div>
                  <img src="../assets/img/ns.png" class="ns" />
                </div>
                <div class="resContent">
                  {{ record.resContent }}
                </div>
              </div>
            </div>

            <div  v-if="loading"  style="display: flex;justify-content: flex-start;align-self: self-start;margin-top: 20px">
              <div>
                <img src="../assets/img/ns.png" style="width: 2rem;float: left;margin-right: 0.5vw" />
              </div>
              <div class="resContent loading-label">
                <span>我在思考中</span>
                <div class="left">
                  <svg xmlns="http://www.w3.org/2000/svg" width="30" height="14" fill="#fff" viewBox="0 0 120 30">
                    <circle cx="15" cy="15" r="15" fill="var(--primary, black)">
                      <animate attributeName="r" begin="0s" calcMode="linear" dur="0.8s" from="15"
                        repeatCount="indefinite" to="15" values="15;9;15">
                      </animate>
                      <animate attributeName="fill-opacity" begin="0s" calcMode="linear" dur="0.8s" from="1"
                        repeatCount="indefinite" to="1" values="1;.5;1">
                      </animate>
                    </circle>
                    <circle cx="60" cy="15" r="9" fill="var(--primary, black)" fill-opacity="0.3">
                      <animate attributeName="r" begin="0s" calcMode="linear" dur="0.8s" from="9"
                        repeatCount="indefinite" to="9" values="9;15;9">
                      </animate>
                      <animate attributeName="fill-opacity" begin="0s" calcMode="linear" dur="0.8s" from="0.5"
                        repeatCount="indefinite" to="0.5" values=".5;1;.5">
                      </animate>
                    </circle>
                    <circle cx="105" cy="15" r="15" fill="var(--primary, black)">
                      <animate attributeName="r" begin="0s" calcMode="linear" dur="0.8s" from="15"
                        repeatCount="indefinite" to="15" values="15;9;15">
                      </animate>
                      <animate attributeName="fill-opacity" begin="0s" calcMode="linear" dur="0.8s" from="1"
                        repeatCount="indefinite" to="1" values="1;.5;1">
                      </animate>
                    </circle>
                  </svg>
                </div>
                <!-- <div style="padding-top: 0.2rem"><svg viewBox="25 25 50 50" class="circular"><circle cx="50" cy="50" r="20" fill="none" class="path"></circle></svg></div>  -->
              </div>
            </div>
          </div>
          <div style="display: flex;margin-top: 5vh;">
            <img src="../assets/img/yx/yx_fl06b.png" style="width:6vh;" @click.prevent="dealIat" />
            <div style=" background-color:rgb(114, 140, 173,0.5);border-radius: 2vw;height: 6vh;margin-left: 1vw;  
                width: 60%; position: relative;box-shadow: 1px 8px 16px rgba(255, 255, 255, 0.3);">
              <input class="ask-input" @keydown.enter="keyWordMethod" v-model="askContent" placeholder="请输入" />
              <!-- <button  class="pause-button" >中断</button> -->
              <button :class="[customButton, { 'disabledButton': loading }]" :disabled="loading"
                @click="keyWordMethod">发送</button>
              <div class="hidden-ele">
                <button class="custom-button" @click="pauseAudio">中断</button>
                <button class="custom-button" @click="changeMute">{{ !changeMuteFlag ? "静音" : "恢复" }}</button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <img :src="qrCodeUrl" class="show-code" alt="QR Code" />
    </div>
  </div>
</template>
<script>
import QRCode from 'qrcode';
import { v4 as uuidv4 } from 'uuid';

export default {
  name: "DigitalH5",
  data() {
    return {
      API_SECRET: "NzVmNzA3NjI2ODE4ODdlY2ZhYmRkZjhl",
      API_KEY: "ce9dc9b423e8036f66c252329e3844a2",
      btnStatus: "UNDEFINED", // "UNDEFINED" "CONNECTING" "OPEN" "CLOSING" "CLOSED"
      recorder: null,
      iatWS: null,
      resultInfo: "",
      accessToken: "",
      modelType: 70001,
      gameInstance: null,
      chatHistory: [],
      askContent: "",
      showGif: false,
      readonlyFlag: false,
      specialSymbols: "。？，；‘’“”!@#$%^&*()_+:`~",
      digitalAccessToken: "",
      chatPageParam: {
        chatSession: "",
        pageNo: 1,
        pageSize: 10,
      },
      qrCodeUrl:"",
      ws:null,
      interval:null,
      imageUrl:'/img/nbg/js.png',
      cacheChat:{},
      iatFlag:false,
      remainingTime:30,
      timerNum:null,
      hasMessageFlag:false,
      loading:false,
      customButton:"custom-button",
      isActive:false,
      changeMuteFlag:false,
      responseIndex:0,
      responseTimerNum:0,
      uuid:null,
    };
  },

  mounted() {
    this.speech()
    window.callMssage = (param) => {
      this.callMssage(param);
    };
    window.callCatMssage = (param) => {
      this.callCatMssage(param);
    };
    let userInfo = this.$getUserInfo();
    if(!userInfo){
     let uuid = localStorage.getItem("UNIQUE_TOKEN")
      if(uuid){
          this.userDeviveLogin(uuid)
      }else{
          uuid = uuidv4();
          uuid = localStorage.setItem("UNIQUE_TOKEN",uuid)
          this.userDeviveLogin(uuid)
      }
      this.uuid = uuid
    }else{
      this.getChatGreet();
      this.generateQRCode();

    }
    // this.getDigitalAccessToken();
    this.initDigitalHuman();

    this.initRecorder();
    // this.getChatGreet();
    this.interval = setInterval(() => {
      this.getSayInfo();
    }, 2000);

  },
   
  beforeDestroy() {
    clearInterval(this.interval); // 清除定时器
  },
  methods: {
    userDeviveLogin(uuid){
      let loginInfo = {
            account: uuid,
            grantType:"device"
      }
      this.$axios.post(this.$urls.loginUrl,loginInfo).then((res)=>{
          if(res.code==0){
            res.data.type = "H5_SAY"
            localStorage.setItem("USER_INFO",JSON.stringify(res.data))
            this.getChatGreet();
            this.generateQRCode();
          }else{
            this.$message({
                 message:res.msg,
                  type: 'warning'
            });
          }
        }) 
    },
    changeMute(){
      if(!this.changeMuteFlag){
          this.mute()
      }else{
        this.unMute()
      }
      this.changeMuteFlag = !this.changeMuteFlag
    },
    mute(){
      const data = {
        methed: 'Mute'
      };
      this.sendMessageToUnity(JSON.stringify(data));
    },
    unMute(){
      const data = {
        methed: 'UnMute'
      };
      this.sendMessageToUnity(JSON.stringify(data));
    },
    pauseAudio() {
      const data = {
        methed: 'PauseAudio'
      };
      this.sendMessageToUnity(JSON.stringify(data));
    },
    unPauseAudio() {
      const data = {
        methed: 'UnPauseAudio'
      };
      this.sendMessageToUnity(JSON.stringify(data));
    },
    stopAudio() {
      const data = {
        methed: 'StopAudio'
      };
      this.sendMessageToUnity(JSON.stringify(data));
    },
    dealIat(){
      // if(!this.iatFlag){
      //   this.iatStart()
      //      this.timerNum = setInterval(() => {
      //      if (this.remainingTime > 0) {
      //        this.remainingTime--;
      //         } else {
      //           if(this.timerNum){
      //              clearInterval(this.timerNum );

      //         }
      //          this.iatStop()
      //          this.iatFlag = !this.iatFlag 
      //          this.remainingTime = 30
      //       }
      //     }, 1000); // 每秒执行一次
      // }else{
      //   if(this.timerNum){
      //     clearInterval(this.timerNum );

      //   }
      //   this.iatStop()
      //   this.remainingTime = 30
      // }
      // this.iatFlag = !this.iatFlag 

      if(!this.isChat()){
        return
      } 
      if(!this.iatFlag){
        this.iatFlag = !this.iatFlag
        this.iatStart()
           this.timerNum = setInterval(() => {
           if (this.remainingTime > 0) {
             this.remainingTime--;
              } else {
                if(this.timerNum){
                   clearInterval(this.timerNum );

              }
               this.iatStop()
               this.iatFlag = !this.iatFlag 
               this.remainingTime = 30
            }
          }, 1000); // 每秒执行一次
      }else{
        this.$message({
          message: '我正在聆听您的问题',
          type: 'warning'
        }); 
        return 

      }
    },
    dealIatStop(){
        
        if(this.timerNum){
            clearInterval(this.timerNum );
          }
          this.iatStop()
          this.remainingTime = 30
          this.iatFlag = !this.iatFlag 
  
      },
    callCatMssage(json){
      this.loading = false
      const regex = /{[^{}]*}/;
      const match = json.match(regex);

      if (match) {
        json = match[0];
      } 
      const data = JSON.parse(json);

      if (!this.cacheChat[data.messageId]) {
          this.cacheChat[data.messageId] = {};
      }
      console.log("xxxxcacheChat",this.cacheChat[data.messageId])

      this.cacheChat[data.messageId][data.seq] = data.replyMessage
      console.log("cacheChatcacheChatcacheChatcacheChat",this.cacheChat[data.messageId])
      // this.$set(this.cacheChat, data.seq, data.replyMessage);
      if( this.chatHistory&& this.chatHistory.length>0){
        const lastData = this.getLastChatMsg(data.messageId)

        if(lastData&&lastData.messageId){
          let i = 1
          let str=''
          while(this.cacheChat[data.messageId][i]){
            str+=this.cacheChat[data.messageId][i]
            i++
          }
          lastData.resContent = str
        }else{
          this.chatHistory.push({
            resContent: data.replyMessage,
            messageId: data.messageId
          });
        }
      }else{
        this.chatHistory.push({
          resContent: data.replyMessage,
          messageId: data.messageId
        });
      }
      if(data.status == 1){
        delete this.cacheChat[[data.messageId]];
        // this.cacheChat = {}
        this.readonlyFlag = false;

      }
    
      this.$nextTick(function () {
        const container = this.$refs.scrollContainer;
        if (container) {
          container.scrollTop = container.scrollHeight + 100;
        }
      });


    }, 
    getLastChatMsg(msgId){
      
      if(!this.hasMessageFlag){
        this.hasMessageFlag = true
        return null
      }
      for (let i = this.chatHistory.length - 1; i >= 0; i--) {
          if(this.chatHistory[i].messageId&&this.chatHistory[i].messageId ==msgId )  {
            return this.chatHistory[i]
          }
      }
      return null;
    },
    handleCommand(command){
        this.imageUrl = '/img/nbg/'+command+'.png'
    },
    handleCommandModel(command){
      this.modelType = Number(command);
      const data = {
        methed: 'SwitchingModel',
        modelId: Number(command)
      };
      this.sendMessageToUnity(JSON.stringify(data));
      console.log(command,"sssssssssssss")
    },
    generateQRCode(){
      let userInfo =  this.$getUserInfo();
      if(!userInfo){
        this.$router.push('/login'); // 跳转到名为'dashboard'的路由页面
      }
      const url =  process.env.VUE_APP_QR_CODE_URL+"?"+"token="+userInfo.accessToken+"&type=H5_SAY"; // 你想要生成二维码的链接
      console.log("url",url)
      QRCode.toDataURL(url)
        .then((url) => {
          this.qrCodeUrl = url
        })
        .catch((error) => {
          console.error(error);
        });
    },
    getSayInfo(){
      let userInfo =  this.$getUserInfo();
      let params={
        key:userInfo.accessToken 
      }
      this.$axios.post(this.$urls.getSayInfo,params).then((res) => {
        if(res&&res.data){
          console.log("getSayInfogetSayInfo",res)
          this.askContent = res.data
          this.catChat()
        }
      });
    },
    isMobileDevice() {//判断是不是手机端在浏览
      return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    },
    send(str) {
      const data = {
        methed: "RequestAudio",
        text: str,
        audioName: "Female1",
        volume: 60,
      };
      this.sendMessageToUnity(JSON.stringify(data));
    },
    getChatGreet() {
      this.$axios.get(this.$urls.chatGreeting).then((res) => {
        console.log("/app-api/digital/ai/chat/chatGreeting---resres", res);
        if (res.code == 0 && res.data) {
          this.send(res.data);
        }
        this.getChatHistory();
      });
    },
    preventContextMenu(event) {
      event.preventDefault(); // 阻止默认的上下文菜单行为
    },
    getDigitalAccessToken() {
      this.$axios.post(this.$urls.getAccessToken).then((res) => {
        console.log("resres", res);
        if (res.code == 0) {
          this.digitalAccessToken = res.data.accessToken;
          this.initDigitalHuman();
        }
      });
    },

    initRecorder() {
      this.recorder = new RecorderManager("/dist");

      this.recorder.onStart = () => {
        this.changeBtnStatus("OPEN");
      };

      this.recorder.onFrameRecorded = ({ isLastFrame, frameBuffer }) => {
        if (this.iatWS.readyState === this.iatWS.OPEN) {
          this.iatWS.send(
            JSON.stringify({
              data: {
                status: isLastFrame ? 2 : 1,
                format: "audio/L16;rate=16000",
                encoding: "raw",
                audio: this.toBase64(frameBuffer),
              },
            })
          );
          if (isLastFrame) {
            this.changeBtnStatus("CLOSING");
          }
        }
      };
      this.recorder.onStop = () => {
        // clearInterval(countdownInterval);
        console.log("关闭关闭、、、、、、、、");
      };
    },
    initDigitalHuman() {
      this.gameInstance = createUnityInstance(
        document.querySelector("#unity-canvas"),{
        dataUrl: "Build/ai-digital-human-7z.data.unityweb",
        frameworkUrl: "Build/ai-digital-human-7z.framework.js.unityweb",
        codeUrl: "Build/ai-digital-human-7z.wasm.unityweb",
          streamingAssetsUrl: "StreamingAssets",
          companyName: "DefaultCompany",
          productName: "ai-digital-human",
          productVersion: "0.1.0",
          // matchWebGLToCanvasSize: false, // Uncomment this to separately control WebGL canvas render size and DOM element size.
          // devicePixelRatio: 1, // Uncomment this to override low DPI rendering on high DPI displays.
        }
      );

      // this.gameInstance = createUnityInstance(document.querySelector("#unity-canvas"), {
      //   dataUrl: "Build/ai-digital-human-7z.data",
      //   frameworkUrl: "Build/ai-digital-human-7z.framework.js",
      //   codeUrl: "Build/ai-digital-human-7z.wasm",
      //   streamingAssetsUrl: "StreamingAssets",
      //   companyName: "DefaultCompany",
      //   productName: "ai-digital-human",
      //   productVersion: "0.1.0",
      //   // matchWebGLToCanvasSize: false, // Uncomment this to separately control WebGL canvas render size and DOM element size.
      //   // devicePixelRatio: 1, // Uncomment this to override low DPI rendering on high DPI displays.
      // });

      console.log("gameInstancegameInstance", this.gameInstance);
      this.init();
    },
    keyWordMethod() {
      // console.log("keyWordMethodkeyWordMethodkeyWordMethod");
      // window.parent.postMessage({ hello: 'world' }, '*');
      if(!this.isChat()){
        return
      }
      this.catChat();
    },
    isChat(){
      if(this.readonlyFlag){
        this.$message({
          message: '请等数智人回答完后再提问',
          type: 'warning'
        });
        return false
      }
      return true
    },
    callMssage(msg) {
      console.log("callMssagecallMssagecallMssagecallMssagecallMssage",msg)
      this.readonlyFlag = false;
      this.chatHistory.push({
        reqContent: this.askContent,
        resContent: msg,
      });
      this.askContent = "";
      this.$nextTick(function () {
        const container = this.$refs.scrollContainer;
        if (container) {
          console.log(
            "container.scrollHeightcontainer.scrollHeightcontainer.scrollHeight",
            container.scrollTop,
            container.scrollHeight
          );

          container.scrollTop = container.scrollHeight + 100;
        }
      });
    },
    iatStart() {
      console.log("开始录音");
      if(!this.isChat()){
        return
      }
      this.showGif = true;
      this.askContent = "";
      this.resultInfo = "";
      if (this.btnStatus === "UNDEFINED" || this.btnStatus === "CLOSED") {
        this.connectWebSocket();
      } else if (this.btnStatus === "CONNECTING" || this.btnStatus === "OPEN") {
        // 结束录音
        this.recorder.stop();
      }
    },
    iatStop() {
      this.showGif = false;
      this.recorder.stop();
      this.changeBtnStatus("CLOSED");
      console.log("关闭录音");
    },
    getWebSocketUrl() {
      var url = "wss://iat-api.xfyun.cn/v2/iat";
      var host = "iat-api.xfyun.cn";
      var apiKey = process.env.VUE_APP_IAT_API_KEY;
      var apiSecret = process.env.VUE_APP_IAT_API_SECRET;
      var date = new Date().toGMTString();
      var algorithm = "hmac-sha256";
      var headers = "host date request-line";
      var signatureOrigin = `host: ${host}\ndate: ${date}\nGET /v2/iat HTTP/1.1`;
      var signatureSha = CryptoJS.HmacSHA256(signatureOrigin, apiSecret);
      var signature = CryptoJS.enc.Base64.stringify(signatureSha);
      var authorizationOrigin = `api_key="${apiKey}", algorithm="${algorithm}", headers="${headers}", signature="${signature}"`;
      var authorization = btoa(authorizationOrigin);
      url = `${url}?authorization=${authorization}&date=${date}&host=${host}`;
      return url;
    },
    connectWebSocket() {
      const websocketUrl = this.getWebSocketUrl();
      if ("WebSocket" in window) {
        this.iatWS = new WebSocket(websocketUrl);
      } else if ("MozWebSocket" in window) {
        this.iatWS = new MozWebSocket(websocketUrl);
      } else {
        alert("不支持WebSocket");
        return;
      }
      this.changeBtnStatus("CONNECTING");
      this.iatWS.onopen = (e) => {
        // 开始录音
        this.recorder.start({
          sampleRate: 16000,
          frameSize: 1280,
        });
        var params = {
          common: {
            app_id: process.env.VUE_APP_IAT_APPID,
          },
          business: {
            language: "zh_cn",
            domain: "iat",
            accent: "mandarin",
            vad_eos: 5000,
            // dwa: "wpgs",
          },
          data: {
            status: 0,
            format: "audio/L16;rate=16000",
            encoding: "raw",
          },
        };
        this.iatWS.send(JSON.stringify(params));
      };
      this.iatWS.onmessage = (e) => {
        this.renderResult(e.data);
      };
      this.iatWS.onerror = (e) => {
        console.error(e);
        this.recorder.stop();
        this.changeBtnStatus("CLOSED");
      };
      this.iatWS.onclose = (e) => {
        this.recorder.stop();
        this.changeBtnStatus("CLOSED");
      };
    },
    changeBtnStatus(status) {
      this.btnStatus = status;
      if (status === "CONNECTING") {
        // btnControl.innerText = "建立连接中";
        // document.getElementById("result").innerText = "";
        // resultText = "";
        // resultTextTemp = "";
        console.log("建立链接中");
      } else if (status === "OPEN") {
        this.countdown();
      } else if (status === "CLOSING") {
        // btnControl.innerText = "关闭连接中";
      } else if (status === "CLOSED") {
        // btnControl.innerText = "开始录音";
      }
    },
    renderResult(resultData) {
      let resultText = "";
      let resultTextTemp = "";
      console.log("resultDataresultData", resultData);
      // 识别结束
      let jsonData = JSON.parse(resultData);
      if (jsonData.data && jsonData.data.result) {
        let data = jsonData.data.result;
        let str = "";
        let ws = data.ws;
        for (let i = 0; i < ws.length; i++) {
          str = str + ws[i].cw[0].w;
        }
        // 开启wpgs会有此字段(前提：在控制台开通动态修正功能)
        // 取值为 "apd"时表示该片结果是追加到前面的最终结果；取值为"rpl" 时表示替换前面的部分结果，替换范围为rg字段
        if (data.pgs) {
          if (data.pgs === "apd") {
            // 将resultTextTemp同步给resultText
            resultText = resultTextTemp;
          }
          // 将结果存储在resultTextTemp中
          resultTextTemp = resultText + str;
        } else {
          resultText = resultText + str;
        }
        if (this.specialSymbols.indexOf(resultTextTemp) < 0 ||
          this.specialSymbols.indexOf(resultText) < 0) {
          // this.resultInfo = resultTextTemp || resultText || "";
          this.resultInfo =  this.resultInfo+(resultTextTemp || resultText || "");

          console.log(
            "resultInfo",
            resultText,
            resultTextTemp,
            this.resultInfo
          );
        }
      }
      if (jsonData.code === 0 && jsonData.data.status === 2) {
        this.iatWS.close();
        this.askContent = this.resultInfo;
        this.keyWordMethod()

      }
      if (jsonData.code !== 0) {
        this.iatWS.close();
        console.error(jsonData);
      }
    },
    countdown() {
      // let seconds = 60;
      // btnControl.innerText = `录音中（${seconds}s）`;
      // countdownInterval = setInterval(() => {
      //   seconds = seconds - 1;
      //   if (seconds <= 0) {
      //     clearInterval(countdownInterval);
      //     recorder.stop();
      //   } else {
      //     btnControl.innerText = `录音中（${seconds}s）`;
      //   }
      // }, 1000);
    },
    init() {
      console.log("init");
      let userInfo = this.$getUserInfo();
      const data = {
        url: process.env.VUE_APP_API_URL,
        methed: "Init",
        // token: this.digitalAccessToken,
        token:this.uuid,
        modelId: this.modelType,
        show: true,
        socket:  process.env.VUE_APP_WEB_SOCKET_URL,
        audioName:"Female2",
        chatSession: String(userInfo.memberId),

      };
      console.log("token", this.digitalAccessToken);
      this.sendMessageToUnity(JSON.stringify(data));
    },
    sendMessageToUnity(obj) {
      if (this.gameInstance == null) {
        console.log("Unity gameInstance = null");
        return;
      }
      this.gameInstance
        .then((g) => {
          console.log("Unity gameInstance" + obj);
          const data = JSON.parse(obj);
          g.Module.SendMessage("AudioManager", data.methed, obj);
        })
        .catch((error) => {
          console.log("Unity gameInstance:", error);
        });
    },
    chat() {
      if (this.askContent != "" && this.askContent != null) {
        let audioName = ""
        if(this.modelType ==70001 ){
          audioName = "Female2"
        }else{
          audioName = "Male3" 
        }

        let userInfo = this.$getUserInfo();
        this.readonlyFlag = true;
        const data = {
          methed: "Chat",
          text: this.askContent,
          audioName: audioName,
          volume: 60,
          chatSession: String(userInfo.memberId),
        };
        this.askContent = "";
        this.chatHistory.push

        this.sendMessageToUnity(JSON.stringify(data));
      } else {
        message.alertError("请输入问题");
      }
    },
    catChat() {

      if (this.askContent != "" && this.askContent != null) {

        clearTimeout(this.responseTimerNum)
        this.loading = true
        this.chatHistory.push({
          "reqContent": this.askContent
        })

        let audioName = ""
        if (this.modelType == 70001) {
          audioName = "Female2"
        } else {
          audioName = "Male3"
        }
        let userInfo = this.$getUserInfo();
        this.readonlyFlag = true;
        const data = {
          methed: "CatChat",
          text: this.askContent,
          audioName: audioName,
          volume: 60,
          chatSession: String(userInfo.memberId),
        };
       this.sendMessageToUnity(JSON.stringify(data));
       this.responseTimerNum = setTimeout(()=>{
            if(this.loading){
              this.chatHistory.push({
                   resContent: "我的网络在知识的海洋迷了路，请稍等一会儿再来提问。",
              });
              this.loading = false;
              this.readonlyFlag = false;
            }
        },10000)
        this.$nextTick(function () {
          const container = this.$refs.scrollContainer;
          if (container) {
            container.scrollTop = container.scrollHeight + 100;
          }
        });
        this.askContent = ""
      } else {
        this.$message.error("请输入问题");
      }

    }, 
    toBase64(buffer) {
      var binary = "";
      var bytes = new Uint8Array(buffer);
      var len = bytes.byteLength;
      for (var i = 0; i < len; i++) {
        binary += String.fromCharCode(bytes[i]);
      }
      return window.btoa(binary);
    },

    getChatHistory() {
      let userInfo = this.$getUserInfo();
      const chatPageParam = {
        chatSession: userInfo.memberId,
        pageNo: 1,
        pageSize: 50,
      };
      this.$axios
        .post(this.$urls.chatPage, chatPageParam)
        .then((res) => {
          if (res.code == 0 && res.data.list.length > 0) {
            // this.chatHistory = res.data.list.reverse();
            res.data.list.reverse().forEach(element => {
              if(element.reqContent){
                this.chatHistory.push({"reqContent":element.reqContent})
              }
              if(element.resContent){
                this.chatHistory.push({"resContent":element.resContent})
              }
            });
            this.$nextTick(function () {
              const container = this.$refs.scrollContainer;
              if (container) {
                container.scrollTop = container.scrollHeight + 100;
              }
            });
          }
        });
    },
  },
};
</script>
<style scoped>

.circular {
  height: 1.2rem;
  width: 1.2rem;
  animation: loading-rotate 2s linear infinite;
}

.path {

  animation: loading-dash 1.5s ease-in-out infinite;
  stroke-dasharray: 90, 150;
  stroke-dashoffset: 0;
  stroke-width: 2;
  stroke: #409eff;
  stroke-linecap: round
}

@keyframes loading-rotate {
  to {
    transform: rotate(1turn)
  }
}

@keyframes loading-dash {
  0% {
    stroke-dasharray: 1, 200;
    stroke-dashoffset: 0
  }

  50% {
    stroke-dasharray: 90, 150;
    stroke-dashoffset: -40px
  }

  to {
    stroke-dasharray: 90, 150;
    stroke-dashoffset: -120px
  }
}



@media screen and (min-width:768px ) {

  .setting-button{
    color: #41778c;
    font-size: 1.3rem
  }


  .loading-label{
    width: 15vw !important;
    align-items: center !important;
    flex-direction: row !important;
    justify-content:first baseline !important;
    /* align-items: center */
}
  .qt{
    width: 2rem;
    display: block;
  }

  .ns{
    width: 2rem;
    float: left;
    margin-right: 0.5vw
  }
  .canvas-show{
    width: 40%; height: 90%;margin-top: 5%;position: relative;
  }
  .show-window{
    width: 58%; height: 80%;margin-top: 17vh;display: flex;flex-direction: column;
  }
 .reqContent{
          border: 1vw solid #174f9a;
                    background-color:#174f9a;
                      margin-right: 10px;
                      max-width:60%;
                      border-radius: 1vw;
                      color: rgb(255, 255, 255);
                      text-align: left;font-size: 1.3rem;white-space: pre-wrap ;
 } 
 
 .resContent{
  border: 20px solid rgb(255, 255, 255);
                           background-color: rgb(255, 255, 255);
                           border-radius: 1vw;
                           display: flex;
                           flex-direction: column;
                           text-align: left;
                           white-space: pre-wrap;
                           font-size: 1.3rem;
                           width: 60%;
 }
 .ask-input{
  outline: none;border: none;width: 99%;height:5.5vh;float: left;
  border-radius:  2vw;background-color:rgb(138, 152, 162,0) ;color: #FFFFFF;font-size: 1.2rem;
 }
 .show-content {
  overflow-y: auto;
  height: 70%;
  overflow-x:hidden;
   border: 2vw solid transparent;
 /* border-image-slice: 30 fill; */
  display: flex;
  flex-direction: column;
  background-color:rgb(165, 194, 229,0.5) ;
  border-radius: 10px;
    box-shadow: 1px 8px 16px rgba(0, 0, 0, 0.3);
    background-size: cover;
    background-position: center;
	backdrop-filter: blur(30px);

  }
  .show-code{
    position: absolute;
          top: 5%;
          width:5vw;
          left: 10vw;
          height: 5vw;
          z-index: 9999;
          left: 88vw;
  }
  .hidden-ele{
    display: inline;
  }
  .gitContainer {
  position: absolute;
  top: 80%;
  left:48%;
  transform: translate(0%, -200%);
  z-index: 999999;
  /* background-image: url("../assets/img/1.gif"); */
  /* 替换为你的 GIF 图片路径 */
  background-color:rgb(255, 255, 255,0.5) ;
  background-size: cover;
  display: block;
  margin: 0 auto;
  padding: 2vw;
  border-radius: 2vw;
  box-shadow: 1px 8px 16px rgba(0, 0, 0, 0.3);
  backdrop-filter: blur(30px);
}

.custom-button {
        padding: 1vh 1.6vh;
        background-color: #1b4899; /* 按钮背景色 */
        color: white;
        height: 6vh;
        line-height:1.5rem;
        border: none;
        border-radius: 2vw; /* 圆角 */
        text-transform: uppercase; /* 文本大写 */
        font-weight: bold; /* 粗体文本 */
        text-align: center;
        text-decoration: none;
        display: inline-block;
        transition: background-color 0.3s, box-shadow 0.3s; /* 过渡效果 */
        box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1); /* 阴影效果 */
        cursor: pointer;
        margin-left:2%;
        font-size: 1.1rem;

    }

    .custom-button:hover {
        background-color: #2980b9; /* 悬停时的背景色 */
        box-shadow: 0 6px 8px rgba(0, 0, 0, 0.2); /* 悬停时的阴影效果 */
    }

    .custom-button:active {
        background-color: #1f618d; /* 点击时的背景色 */
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2); /* 点击时的阴影效果 */
    }


}


@media screen and (max-width:768px ) {

  .custom-button {
        padding: 1vh 1.6vh;
        background-color: #1b4899; /* 按钮背景色 */
        color: white;
        height: 6vh;
        line-height:1.5rem;
        border: none;
        border-radius: 2vw; /* 圆角 */
        text-transform: uppercase; /* 文本大写 */
        font-weight: bold; /* 粗体文本 */
        text-align: center;
        text-decoration: none;
        display: inline-block;
        transition: background-color 0.3s, box-shadow 0.3s; /* 过渡效果 */
        box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1); /* 阴影效果 */
        cursor: pointer;
        margin-left:2%;
        width: 20vw;
        font-size: 1rem;

    }

    .custom-button:hover {
        background-color: #2980b9; /* 悬停时的背景色 */
        box-shadow: 0 6px 8px rgba(0, 0, 0, 0.2); /* 悬停时的阴影效果 */
    }

    .custom-button:active {
        background-color: #1f618d; /* 点击时的背景色 */
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2); /* 点击时的阴影效果 */
    }



  .setting-button{
    color: #41778c;
    font-size: 1rem
  }

  .loading-label{
    width: 60vw !important;
    align-items: center !important;
    flex-direction: row !important;
    justify-content:first baseline !important;
    /* align-items: center */
}

.left{

 margin-left: 2vw;

}
  .qt{
    width: 7vw;
    display: block;
  }

  .ns{
    width: 7vw;
    float: left;
    margin-right: 0.5vw
  }

  .canvas-show{
     width: 80%; height: 90%;margin-top: 5%;position: absolute;left: 10%;
  }
  .show-window{
    width: 90vw; height: 80%;margin-top: 17vh;display: flex;flex-direction: column;z-index: 9999;margin-left: 5%;
  }
  .show-content {
    margin-top:65%;
  overflow-y: auto;
  height: 50%;
  overflow-x:hidden;
   border: 2vw solid transparent;
 /* border-image-slice: 30 fill; */
  display: flex;
  flex-direction: column;
  background-color:rgb(165, 194, 229,0.1) ;
  border-radius: 10px;
    box-shadow: 1px 8px 16px rgba(0, 0, 0, 0.3);
    background-size: cover;
    background-position: center;
}
.reqContent{
          border: 1vw solid transparent;
                    background-color:rgba(23, 79, 154,0.4);
                      margin-right: 0.5vw;
                      max-width:60%;
                      border-radius: 1vw;
                      color: rgb(255, 255, 255);
                      line-height: 3vh;
                      text-align: left;font-size: 1rem;white-space: pre-wrap ;
 }
 .resContent{
                         border-left: 3vw solid transparent;
                         border-top: 3vw solid transparent;
                         border-bottom: 3vw solid transparent;
                         border-right: 2vw solid transparent;
                         background-color:rgba(23, 79, 154,0.4);
                           border-radius: 1vw;
                           display: flex;
                           flex-direction: column;
                           text-align:left ;
                           white-space: pre-wrap;
                           font-size: 1rem;
                           color: rgb(255, 255, 255,1);
                           line-height: 3vh;
                           width:64vw;
                           
 }
 .ask-input{
  outline: none;border: none;width:100%;height:5.5vh;float: left;margin-right: 2%;
  border-radius:  2vw;background-color:rgb(138, 152, 162,0) ;color: #FFFFFF;font-size: 1rem;
 }

 .show-code{
          display: none;
  }
  .hidden-ele{
    display: none;
  }
  .gitContainer {
  position: absolute;
  top: 80%;
  left:30%;
  transform: translate(0%, -200%);
  z-index: 999999;
  /* background-image: url("../assets/img/1.gif"); */
  /* 替换为你的 GIF 图片路径 */
  background-color:rgb(255, 255, 255,0.5) ;
  background-size: cover;
  display: block;
  margin: 0 auto;
  padding: 2vw;
  border-radius: 2vw;
  box-shadow: 1px 8px 16px rgba(0, 0, 0, 0.3);
  backdrop-filter: blur(30px);
}
}



/* 按钮置灰样式 */
.disabledButton {
    opacity: 0.5; /* 降低不透明度 */
    pointer-events: none; /* 禁用指针事件 */
    cursor: not-allowed; /* 修改鼠标指针样式为不可用 */
    background-color: #ccc; /* 修改背景颜色为灰色 */
    color: #666; /* 修改字体颜色为深灰色 */
    border: 1px solid #999; /* 添加边框 */
}
.pause-button:hover {

        background-color: #0e5ae3; /* 鼠标点击后的背景色 */

}
.pause-button{
  border: none; 
  outline: none;  
  height: 6vh;
  margin-left:5%;
  width: 4vw;
  color: #FFFFFF;
  font-size: 1.2vw;
  background-color: #1b4899;
  border-radius: 2vw;
  box-shadow: 1px 8px 16px rgba(255, 255, 255, 0.3);
}

.custom-button {
        padding: 1vh 1.6vh;
        background-color: #1b4899; /* 按钮背景色 */
        color: white;
        height: 6vh;
        line-height:1.5rem;
        border: none;
        border-radius: 2vw; /* 圆角 */
        text-transform: uppercase; /* 文本大写 */
        font-weight: bold; /* 粗体文本 */
        text-align: center;
        text-decoration: none;
        display: inline-block;
        transition: background-color 0.3s, box-shadow 0.3s; /* 过渡效果 */
        box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1); /* 阴影效果 */
        cursor: pointer;
        margin-left:2%;
        font-size: 1.1rem;

    }

    .custom-button:hover {
        background-color: #2980b9; /* 悬停时的背景色 */
        box-shadow: 0 6px 8px rgba(0, 0, 0, 0.2); /* 悬停时的阴影效果 */
    }

    .custom-button:active {
        background-color: #1f618d; /* 点击时的背景色 */
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2); /* 点击时的阴影效果 */
    }



.ask-content{
  /* border: 20px solid transparent;
  border-image-slice: 30 fill; */
  border: 20px solid rgb(255, 255, 255);
  background-color: rgb(255, 255, 255);
  border-radius: 1vw;
  display: flex;
  flex-direction: column;
  margin-top: 2vh;
  text-align: left;
  white-space: pre-wrap;
  font-size: 1.3vw
}
/* .show-content {
  overflow-y: auto;
  height: 70%;
  overflow-x:hidden;
   border: 2vw solid transparent;
  display: flex;
  flex-direction: column;
  background-color:rgb(165, 194, 229,0.5) ;
  border-radius: 10px;
    box-shadow: 1px 8px 16px rgba(0, 0, 0, 0.3);
    background-size: cover;
    background-position: center;
	backdrop-filter: blur(30px);

} */


.show-content::-webkit-scrollbar {
  width: 10px;
  /* 滚动条宽度 */
}


.show-content::-webkit-scrollbar-thumb {
  background-color: #888;
  /* 滑块背景颜色 */
  border-radius: 5px;
  /* 滑块圆角 */
}

.el-dropdown-link {
    cursor: pointer;
    color: #409EFF;
  }
  .el-icon-arrow-down {
    font-size: 12px;
  }

  .el-dropdown-menu__item {
    list-style: none;
    line-height: 2.5vw;
    margin: 0;
    color: #606266;
    outline: 0;
}
.el-dropdown-menu__item, .el-menu-item {
    font-size: 1.2vw;
    padding: 0 20px;
    cursor: pointer;
}


.custom-scrollbar {

  width: 100%;
  height: 100%;
  position: relative;
  padding-bottom: 1vh;
  /* margin: 0 auto; */
  overflow-y: auto;
  box-shadow: rgba(0, 0, 0, 0.1) 0px 2px 12px,
    rgba(0, 0, 0, 0.1) 0px -2px 2px;
  background-color: rgba(255, 255, 255, 0.2);
  padding-top: 1vw;
  white-space: normal;
  border-radius: 3vw;

}

.custom-scrollbar::-webkit-scrollbar {
  width: 10px;
  /* 滚动条宽度 */
}

.custom-scrollbar::-webkit-scrollbar-thumb {
  background-color: #888;
  /* 滑块背景颜色 */
  border-radius: 5px;
  /* 滑块圆角 */
}

.background-div {
  position: relative;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  height: 100vh;
  width: 100vw;
  overflow: hidden;
  white-space: nowrap;
}

/* .background-div::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0.6;
  background-color: black;
} */

.bottom-view {
  width: 96%;
  height: 6vh;
  top: 70%;
  position: absolute;
  padding-bottom: 0.5vh;
  margin: 0 auto;
  box-shadow: rgba(0, 0, 0, 0.5) 0px 2px 12px, rgba(0, 0, 0, 0.5) 0px -2px 2px;
  background-color: rgba(255, 255, 255, 0.3);
  /* bottom: 7vh; */
  white-space: normal;
  border-radius: 2vw;
}

.bottom-view-mobile {
  width: 60vw;
  height: 3vh;
  top: 70%;
  position: absolute;
  padding-bottom: 2vh;
  margin: 0 auto;
  box-shadow: rgba(0, 0, 0, 0.5) 0px 2px 12px, rgba(0, 0, 0, 0.5) 0px -2px 2px;
  background-color: rgba(255, 255, 255, 0.3);
  /* bottom: 7vh; */
  white-space: normal;
  border-radius: 2vw;
}



.local-curcl {
  position: absolute;
  width: 3vw;
  height: 3vw;
  left: 0vw;
  /* top: 0.5vh; */
}
.local-gif-mobile{

  position: absolute;
  top: 1.6vh;
  left: 40px;
  width: 10px;
  z-index: 999;
  height: 15px;
}

.local-gif {
  position: absolute;
  top: 2vh;
  left: 5vw;
  width: 3vw;
  z-index: 999;
  height: 3vh;
}

.local-mkf {
  position: absolute;
  left: 1.0vw;
  top: 1.5vh;
  background-size: contain;
  width: 1.0vw;
  height: 1.5vw;
}


.local-curcl-mobile{
  position: absolute;
  width: 10vw;
  height: 10vw;
  left: 0.1px;
  top: -0.4vh;
  
}

.local-mkf-mobile {
  position: absolute;
  left: 12px;
  top: 1.1vh;
  background-size: contain;
  width: 3vw;
  height: 4.5vw;
}


.local-view-input-mobile{
  position: absolute;
  margin-left: 35px;
  /* flex: 0 0 20%; */
  text-align: left;
  top: 0.5vh;
  height: 3.8vh;
  background-color: #41778c;
  background-size: cover;
  opacity: 0.4;
  width: 84%;
  border-radius: 3vw;
  /* border: 2px solid #e3f9ff;
  outline: 1px solid #bfe3f5; */
  box-shadow: 0 0 2px 2px #bfe3f5;
  font-size: 1.1rem;
  font-family: "Microsoft YaHei";
}


.local-view-input {
  position: absolute;
  margin-left: 4.5vw;
  /* flex: 0 0 20%; */
  text-align: left;
  top: 0.3vw;
  height: 5.5vh;
  background-color: #41778c;
  background-size: cover;
  opacity: 0.4;
  width: 88%;
  border-radius: 3vw;
  /* border: 2px solid #e3f9ff;
  outline: 1px solid #bfe3f5; */
  box-shadow: 0 0 2px 2px #bfe3f5;
  font-size: 1.1rem;
  font-family: "Microsoft YaHei";
}

.local-input-text {
  flex: 0 0 20%;
  margin-left: 8vw;
  opacity: 0.1;
  width: 60vw;
  margin-top: 0.5vh;
  text-align: left;
  color: rgba(255, 255, 255);
  font-size: 4.1vw;
  font-family: "Microsoft YaHei", sans-serif;
  border-radius: 2vw;
  padding: 1vw;
  z-index: 999;
}

.local-keyword-mobile {
  position: absolute;
  right: 2vw;
  top: 1.4vh;
  background-size: contain;
  width: 4.5vw;
  height: 4.5vw;
  z-index: 999;
}

.local-line-mobile {
  position: absolute;
  right: 7.5vw;
  top: 1.5vh;
  z-index: 999;
  background-size: contain;
  width: 0.4vw;
  height: 4vw;
}



.local-keyword {
  position: absolute;
  right: 2vw;
  top: 1.6vh;
  background-size: contain;
  width: 2vw;
  height: 2vw;
  z-index: 999;
}

.local-line {
  position: absolute;
  right: 4.5vw;
  top: 1.6vh;
  z-index: 999;
  background-size: contain;
  width: 0.2vw;
  height: 2vw;
}

.title {
  font-size: 36rpx;
  color: #8f8f94;
}

.container {
  position: relative;
  text-align: left;
  /* 文字居中对齐 */
  /* 设置文字颜色为深灰色 */
  /* font-size: 26rpx; */
  /* 设置文字大小为16像素 */
  /* font-family: "Microsoft YaHei", sans-serif; */
}

.left-image {
  position: absolute;
  /* left: -0.5vw; */
  /* top: 0.5vw; */
  /* background-size: contain; */
  width: 1rem;
  /* 设置图标宽度 */
  height: 1.5rem;
  /* 设置图标高度 */
}


.text {
  /* margin-top: -1vw; */
  /* padding-right: 7vw; */
  /* padding-left: 5vw; */
  /* flex: 0 0 20%; */
  /* 设置文字占据宽度为20% */
  text-align: left;
  /* 文字居中对齐 */
  color: rgba(255, 255, 255);
  /* 设置文字颜色为深灰色 */
  font-size: 1.5vw;
  /* 设置文字大小为16像素 */
  font-family: "Microsoft YaHei";
  line-height: 1.5;
  /* 设置文字字体为Arial或系统默认无衬线字体 */
}


.custom-gif-button {
        padding: 10px 20px;
        background-color: #1b4899; /* 按钮背景色 */
        color: white;
        height:  2.5rem;
        line-height: 2vh;
        border: none;
        border-radius: 1vw; /* 圆角 */
        text-transform: uppercase; /* 文本大写 */
        font-weight: bold; /* 粗体文本 */
        text-align: center;
        text-decoration: none;
        display: inline-block;
        transition: background-color 0.3s, box-shadow 0.3s; /* 过渡效果 */
        box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1); /* 阴影效果 */
        cursor: pointer;
        margin-top: 2vh;
        font-size: 1.1rem;

    }

</style>